import { useEffect, useState } from 'react';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import type { User as FirebaseUser } from 'firebase/auth';
import type { AppUser, UserRole } from '../types/user';

// Type pour un utilisateur qui peut être soit Firebase 
export type AuthUser = FirebaseUser;

export function useUser(authUser: AuthUser | null) {
  const [userDoc, setUserDoc] = useState<AppUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!authUser) {
      setUserDoc(null);
      setLoading(false);
      return;
    }

    console.log('[USE USER] Utilisateur reçu:', authUser);
    
    const fetchUser = async () => {
      setLoading(true);
      try {
        const ref = doc(db, 'users', authUser.uid);
        const snap = await getDoc(ref);
        
        if (snap.exists()) {
          console.log('[USE USER] Document utilisateur trouvé dans Firestore');
          setUserDoc(snap.data() as AppUser);
        } else {
          console.log('[USE USER] Création d\'un nouveau document utilisateur');
          // Détection du rôle initial
          let role: UserRole = 'coach';  // Par défaut, les nouveaux utilisateurs sont des coachs
          
          if (authUser.email === 'jpigra@gmail.com') {
            role = 'admin';
          }
          
          const displayName = authUser.displayName || '';
          
          const userData: AppUser = {
            uid: authUser.uid,
            email: authUser.email || '',
            displayName: displayName,
            role,
            createdAt: new Date(),
            updatedAt: new Date(),
          };
          
          console.log('[USE USER] Données utilisateur à enregistrer:', userData);
          
          await setDoc(ref, {
            ...userData,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
          });
          
          setUserDoc(userData);
        }
      } catch (e: any) {
        console.error('[USE USER] Erreur lors de la récupération/création de l\'utilisateur:', e);
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchUser();
  }, [authUser]);

  return { userDoc, loading, error };
}
